import React from 'react';
import { Wrapper, Content } from './styles';
import PropTypes from 'prop-types';

const Main = (props) => {
  const { children } = props;

  return (
    <Wrapper>
      <Content>{children}</Content>
    </Wrapper>
  );
};

Main.propTypes = {
  children: PropTypes.any
};

export default Main;
